import React from "react";
import * as yup from "yup";
import { Formik, Form } from "formik";
import { Button, Grid } from "@mui/material";

import { DialogContent, DialogActions } from "components/haven-design/modal/dialog";
import { InputWithErrorLabel as Input } from "components/haven-design/form/inputs";
import { Modal } from "components/haven-design";
import { ListBuildingUnits_buildingUnits as BuildingUnitType } from "types/gql-types";
import UnitFormSharedFields, { sharedFieldsValidations } from "./unit-form-shared-fields";

export type AccessibilityOption = "mobility" | "visual" | "hearing"
export type FundingSourceOption = "Tax Credit" | "Tax Exempt Bond" | "HPD ELLA" | "HUD Rental Assistance" | "HUD Project-Based Voucher" | "HUD Tenant Based Housing Choice Voucher"

export type PreferenceOption = "Age Restricted (55+)" | "Age Restricted (62+)" | "Aging out of Foster Care"
| "Artist" | "Disabled" | "Displaced" | "Domestic Violence Survivor" | "Elderly/Disabled (62+)"
| "Employer-Specific Employee" | "Experiencing Homelessness" | "Live Preference" | "Live/Work Preference"
| "Teacher" | "Veteran" | "Work Preference"

type BuildingUnitTypeClean = Omit<BuildingUnitType, "__typename" | "id" | "buildingId">;

const initialValues = {
  name: "",
  bedrooms: "1br",
  bathrooms: 0,
  occupancyMin: 1,
  occupancyMax: 1,
  rentType: "fixed",
  rentValue: 0,
  sqft: 0,
  floor: 0,
  occupied: "Vacant",
  accessibility: [] as AccessibilityOption[],
  fundingSource: [] as FundingSourceOption[],
  preference: [] as PreferenceOption[],
  incomeDesignation: "none",
  isReferral: false,
  referralOrg: "",
} as BuildingUnitTypeClean;

const validationSchema = yup.object().shape({
  ...sharedFieldsValidations,
});

type UnitFormProps = {
  handleAddUnit: (values: BuildingUnitTypeClean) => void,
  open: boolean,
  closeModal: () => void,
}

const UnitForm: React.FC<UnitFormProps> =
({ handleAddUnit, open, closeModal }) => (
  <Modal
    onRequestClose={closeModal}
    isOpen={open}
    title="Add Unit"
    fullScreen
  >
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        handleAddUnit(values);
        closeModal();
      }}
      validationSchema={validationSchema}
    >
      {({ handleSubmit, isSubmitting }) => (<>
        <DialogContent>
          <Form id="add-units" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12 }}><Input margin="none" label="Unit Name" name="name" required /></Grid>
              <UnitFormSharedFields />
            </Grid>
          </Form>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="secondary" onClick={closeModal}>Cancel</Button>
          <Button
            form="add-units"
            variant="contained"
            color="primary"
            type="submit"
            disabled={isSubmitting}
          >
            Add Unit
          </Button>

        </DialogActions>
      </>
      )}
    </Formik>
  </Modal>);

export default UnitForm;
